(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const formatMoney = (cents, currency) => new Intl.NumberFormat('es-GT', { style: 'currency', currency: currency || 'GTQ', maximumFractionDigits: 0 }).format((cents || 0) / 100);
  const setOpen = open => { if (!drawer) return; drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', String(!open)); document.body.style.overflow = open ? 'hidden' : ''; };
  const updateBadges = count => document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
  const renderCart = async () => {
    if (!drawer) return;
    const area = drawer.querySelector('[data-cart-items]'); const total = drawer.querySelector('[data-cart-total]'); const status = drawer.querySelector('[data-cart-status]');
    try {
      const cart = await fetch('/cart.js').then(r => r.json()); updateBadges(cart.item_count || 0); total.textContent = formatMoney(cart.total_price, cart.currency);
      if (status) status.textContent = cart.items.length ? `${cart.item_count} producto${cart.item_count === 1 ? '' : 's'} en tu mesa.` : 'Tu mesa está vacía.';
      if (!cart.items.length) { area.innerHTML = '<p class="cart-empty">Todavía no hay nada en la mesa.</p>'; return; }
      area.innerHTML = cart.items.map(item => `<article class="cart-line" data-cart-line data-cart-key="${item.key}" data-cart-quantity="${item.quantity}"><img src="${item.image || ''}" alt=""><div class="cart-line__content"><h3>${item.product_title}</h3><p class="cart-line__price">${formatMoney(item.final_price, cart.currency)} c/u</p><div class="cart-quantity" aria-label="Cantidad de ${item.product_title}"><button class="cart-quantity__button" type="button" data-cart-delta="-1" aria-label="Disminuir cantidad de ${item.product_title}">−</button><output class="cart-quantity__value" data-cart-line-quantity aria-live="polite">${item.quantity}</output><button class="cart-quantity__button" type="button" data-cart-delta="1" aria-label="Aumentar cantidad de ${item.product_title}">+</button></div></div><button class="cart-line__remove" type="button" data-cart-remove="${item.key}" aria-label="Quitar ${item.product_title} del carrito">Quitar</button></article>`).join('');
    } catch (_) { area.innerHTML = '<p class="cart-empty">No pudimos cargar el carrito. Inténtalo de nuevo.</p>'; }
  };
  const closeHeaderMenu = () => {
    const header = document.querySelector('[data-site-header]');
    const toggle = document.querySelector('[data-header-menu]');
    header?.classList.remove('is-menu-open');
    toggle?.setAttribute('aria-expanded', 'false');
  };
  const closeHeaderSearch = () => {
    const header = document.querySelector('[data-site-header]');
    const toggle = document.querySelector('[data-header-search-toggle]');
    header?.classList.remove('is-search-open');
    toggle?.setAttribute('aria-expanded', 'false');
  };
  document.addEventListener('click', async event => {
    const menuToggle = event.target.closest('[data-header-menu]');
    if (menuToggle) {
      const header = menuToggle.closest('[data-site-header]');
      const open = !header?.classList.contains('is-menu-open');
      header?.classList.toggle('is-menu-open', open);
      menuToggle.setAttribute('aria-expanded', String(open));
      return;
    }
    const searchToggle = event.target.closest('[data-header-search-toggle]');
    if (searchToggle) {
      const header = searchToggle.closest('[data-site-header]');
      const open = !header?.classList.contains('is-search-open');
      header?.classList.toggle('is-search-open', open);
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) header?.classList.remove('is-menu-open');
      header?.querySelector('[data-header-search] input')?.focus();
      return;
    }
    if (!event.target.closest('[data-header-search]') && !event.target.closest('[data-site-header]')) closeHeaderSearch();
    const navLink = event.target.closest('[data-jinro-target]');
    if (navLink) {
      const targets = { soju: "#soju", wholesale: "#mayoristas" };
      const target = document.querySelector(targets[navLink.dataset.jinroTarget]);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      closeHeaderMenu();
      closeHeaderSearch();
    }
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); closeHeaderSearch(); await renderCart(); setOpen(true); }
    if (event.target.closest('[data-cart-close]')) setOpen(false);
    const quantityChange = event.target.closest('[data-cart-delta]');
    if (quantityChange) {
      const line = quantityChange.closest('[data-cart-line]'); const currentQuantity = Number(line?.dataset.cartQuantity || 0); const nextQuantity = Math.max(0, currentQuantity + Number(quantityChange.dataset.cartDelta || 0));
      if (!line?.dataset.cartKey || nextQuantity === currentQuantity) return;
      line.querySelectorAll('button').forEach(button => { button.disabled = true; });
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.dataset.cartKey, quantity: nextQuantity }) });
      await renderCart();
      return;
    }
    const remove = event.target.closest('[data-cart-remove]'); if (remove) { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 }) }); await renderCart(); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeHeaderMenu(); closeHeaderSearch(); } });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-jinro-product-form], .jr-products .jr-card form'); if (!form) return;
    event.preventDefault(); const button = form.querySelector('button[type="submit"]'); const original = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Agregando…'; }
    try { const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) }); if (!response.ok) throw new Error('add failed'); await renderCart(); setOpen(true); }
    catch (_) { form.submit(); }
    finally { if (button) { button.disabled = false; button.innerHTML = original; } }
  });
  renderCart();
})();
